/**
 * @desc Controller for the csProtectionCoverage directive
 */
;(function () {
  angular
    .module('contrast.protection.coverage')
    .controller('csProtectionCoverageCtrl', csProtectionCoverageCtrl)

  function csProtectionCoverageCtrl(
    $scope,
    $timeout,
    PromiseService,
    ErrorService,
    LoadFilterRouteService,
    FeaturesService,
    ApplicationFactory,
    QUICK_FILTERS,
    SERVER_ENVIRONMENT,
    AGENT_FEATURE
  ) {
    'ngInject'

    var vm = this
    var _searchKeywords
    var lastSearch
    var availableLanguages

    angular.extend(vm, {
      showPanel: false,

      searchKeywords: searchKeywords,
      quickFilters: [],
      selectedQuickFilter: {
        name: QUICK_FILTERS.APPS.INCOMPLETE_PROTECTION.VALUE,
        filterType: QUICK_FILTERS.APPS.INCOMPLETE_PROTECTION.KEY,
        count: '?'
      },

      applications: [],
      count: 0,
      numPerLoad: 5,
      busy: true
    })

    angular.extend(vm, {
      togglePanel: togglePanel,
      quickFilterSelect: quickFilterSelect,
      loadByScroll: loadByScroll,
      onAppServersClick: onAppServersClick
    })

    function init() {
      FeaturesService.getEnabledLanguagesByAgentFeature(
        AGENT_FEATURE.PROTECTION
      ).then(function (languages) {
        var i
        availableLanguages = []
        for (i = 0; i < languages.length; i++) {
          availableLanguages = availableLanguages.concat(
            _.map(languages[i], function (lang) {
              return lang
            })
          )
        }

        _refreshApplications()
      })
    }

    function togglePanel() {
      vm.showPanel = !vm.showPanel
    }

    function searchKeywords(newSearchKeywords) {
      if (!arguments.length) {
        return _searchKeywords
      }

      if (newSearchKeywords !== _searchKeywords) {
        _searchKeywords = newSearchKeywords
      }

      _refreshApplications()

      return _searchKeywords
    }

    function quickFilterSelect(filter) {
      vm.selectedQuickFilter = filter
      _refreshApplications(false)
    }

    function loadByScroll() {
      if (vm.applications.length === vm.count || vm.busy) {
        return
      }

      vm.scrollPromise = _loadApplications(
        vm.numPerLoad,
        vm.applications.length
      )

      return vm.scrollPromise
    }

    function onAppServersClick(application) {
      LoadFilterRouteService.goToServersFilteredByApp(
        application.app_id,
        SERVER_ENVIRONMENT.PRODUCTION.value
      )
    }

    function _refreshApplications(reloadQuickFilters) {
      if (angular.isUndefined(reloadQuickFilters) || reloadQuickFilters) {
        PromiseService.cancelPromise(vm.quickFiltersPromise)
        _getQuickFilters()
      }

      vm.applications = []
      vm.applicationsPromise = _loadApplications(vm.numPerLoad, 0)
    }

    function _getQuickFilters() {
      if (vm.quickFiltersPromise) {
        PromiseService.cancelPromise(vm.quickFiltersPromise)
      }

      var filters = {
        includeArchived: false,
        filterText: searchKeywords(),
        filterLanguages: availableLanguages,
        environment: SERVER_ENVIRONMENT.PRODUCTION.value
      }

      vm.quickFiltersPromise =
        ApplicationFactory.getApplicationsQuickFilters(filters)

      vm.quickFiltersPromise
        .then(function (response) {
          vm.quickFilters = response.data.filters

          vm.selectedQuickFilter = vm.quickFilters.find(function (filter) {
            return filter.filterType === vm.selectedQuickFilter.filterType
          })
        })
        .catch(ErrorService.processError)

      return vm.quickFiltersPromise
    }

    function _loadApplications(limit, offset) {
      if (lastSearch) {
        PromiseService.cancelPromise(lastSearch)
      }

      vm.busy = true

      var filters = {
        offset: offset,
        limit: limit,
        expand: 'production_protected',
        sort: 'appName',
        includeArchived: false,
        filterText: searchKeywords(),
        includeMerged: true,
        filterLanguages: availableLanguages,
        quickFilter: vm.selectedQuickFilter.filterType,
        environment: SERVER_ENVIRONMENT.PRODUCTION.value
      }

      lastSearch = ApplicationFactory.getApplicationsByFilter(filters)

      return lastSearch
        .then(function (response) {
          var apps = response.data.applications

          _.each(apps, function (app) {
            var total =
              angular.isDefined(app.production_protected) &&
              angular.isNumber(app.production_protected.total)
                ? app.production_protected.total
                : 0
            var protect =
              angular.isDefined(app.production_protected) &&
              angular.isNumber(app.production_protected.protect)
                ? app.production_protected.protect
                : 0

            app.protectPercent =
              total === 0 ? 0 : Math.floor((100 * protect) / total)
          })

          vm.applications = vm.applications.concat(apps)
          vm.count = response.data.count

          $timeout(function () {
            $scope.$emit('triggerScrollCheck')
          })

          vm.busy = false
        })
        .catch(ErrorService.processError)
        .finally(function () {
          vm.busy = false
        })
    }

    init()
  }
})()
